import { Component, OnInit } from "@angular/core";
import { AuthService } from "../auth/auth/auth.service";
import { HttpClient } from "@angular/common/http";
import { StatusDto } from "./StatusDto";
import { SupportService } from "../support/service/support.service";

@Component({
  selector: "app-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.scss"]
})
export class NavComponent implements OnInit {

  public version: string | null;

  constructor(
    public readonly authService: AuthService,
    public readonly httpClient: HttpClient,
    public readonly supportService: SupportService,
  ) { }

  ngOnInit(): void {
    this.fetchVersion()
      .then((version: string) => {
        this.version = version;
      })
      .catch((error: Error) => {
        console.error(error);
      });
  }

  public async logout(): Promise<void> {
    try {
      const result = await this.authService.logout();
      if (result == null) {
        return;
      } else {
        alert(result);
      }
    } catch (e) {
      alert(e.message);
    }
  }

  public async fetchVersion(): Promise<string> {
    const result = await this.httpClient.get<StatusDto>(`/api/status`).toPromise();
    return result.version;
  }
}
